import { render, staticRenderFns } from "./UnfixedStockDataRow.vue?vue&type=template&id=6aaa4e26&scoped=true&"
import script from "./UnfixedStockDataRow.vue?vue&type=script&lang=ts&"
export * from "./UnfixedStockDataRow.vue?vue&type=script&lang=ts&"
import style0 from "./UnfixedStockDataRow.vue?vue&type=style&index=0&id=6aaa4e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa4e26",
  null
  
)

export default component.exports